import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { useDeleteHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaign;
}

interface IBody {
  fixedPayoutSocials: {
    social: string;
    amount: number;
  }[];
}

export function useRemoveFixedPayouttoCampaignAdminHttp() {
  return useDeleteHttp<IBody, IResponse>({
    path: "/admin/campaigns/:campaignId/fixed-payout",
  });
}
